module.exports = __webpack_public_path__ + "pic/29.c18aa4cb.png";